import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { getAsyncListTippyConfig } from '../config'
import { BAtcFetchListCard } from './BAtcFetchListCard'
export const BAtcPopperListCard = defineComponent({
  name: 'BAtcPopperListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  render() {
    return (
      <PtPopper data={{ ids: this.ids }} tippyConfig={getAsyncListTippyConfig()} component={BAtcFetchListCard}>
        {this.$slots.default}
      </PtPopper>
    )
  },
})
